export interface HomeStat {
    /** i18n key for the big number. */
    value: string;
    /** i18n key for the caption below it. */
    label: string;
    /**
     * Draft stats only render on the dev server. Fill in the copy in
     * i18n/locales/{nl,en}.json and remove this flag to publish.
     */
    draft?: boolean;
}

/**
 * The homepage stats bar. Copy lives in the i18n bundle under `stats.*` so both
 * locales stay in sync; this file controls which stats show and in what order.
 */
export const homeStats: HomeStat[] = [
    { value: 'stats.s1_value', label: 'stats.s1_label' },
    // Replaced "12 AI-integraties": an integration count says nothing to a
    // prospect. Needs a client-facing outcome instead.
    { value: 'stats.s2_value', label: 'stats.s2_label', draft: true },
    { value: 'stats.s3_value', label: 'stats.s3_label' },
    { value: 'stats.s4_value', label: 'stats.s4_label' },
];
